var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.831 10.46a3.608 3.608 0 0 0 3.613 3.613c1.975 0 3.564-1.59 3.564-3.612a3.556 3.556 0 0 0-3.564-3.564c-2.023 0-3.613 1.589-3.613 3.564Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.66 1.674c1.16 1.16 1.517 2.59 1.606 4.197.09 1.651.09 6.607 0 8.258-.089 1.608-.446 2.992-1.607 4.197-1.16 1.16-2.589 1.518-4.196 1.607-1.652.09-6.607.09-8.26 0-1.606-.09-2.99-.446-4.196-1.607C.847 17.12.49 15.736.4 14.129.311 12.479.311 7.522.4 5.872c.09-1.608.447-3.036 1.607-4.197C3.213.514 4.597.156 6.204.067c1.652-.09 6.607-.09 8.259 0 1.607.09 3.036.446 4.196 1.607ZM4.904 10.461a5.54 5.54 0 0 1 5.539-5.54c3.034 0 5.539 2.505 5.539 5.54A5.54 5.54 0 0 1 10.443 16a5.51 5.51 0 0 1-5.538-5.54Zm11.27-7.032c.723 0 1.301.578 1.301 1.3 0 .723-.578 1.3-1.3 1.3-.723 0-1.3-.577-1.3-1.3 0-.722.577-1.3 1.3-1.3Z",
    clipRule: "evenodd"
  })));
};
var Memo = /*#__PURE__*/memo(SvgInstagram);
export default Memo;